module.exports = __webpack_public_path__ + "img/spolar.a64a3af6.svg";